import type { ReactElement, ReactNode } from 'react';

export function MasterRecordPanel({
  testId,
  ariaLabel,
  title,
  status,
  variant = 'panel',
  onClose,
  onBack,
  children
}: {
  testId: string;
  ariaLabel: string;
  title: ReactNode;
  status?: string;
  variant?: 'panel' | 'page';
  onClose?: () => void;
  onBack?: () => void;
  children: ReactNode;
}): ReactElement {
  return (
    <aside
      className={`side-panel${variant === 'page' ? ' side-panel--page' : ''}`}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <div className="side-panel-header">
        <div className="side-panel-title-row">
          {variant === 'page' && onBack && (
            <button type="button" className="secondary panel-back-btn" onClick={onBack}>
              Back to list
            </button>
          )}
          <h3>{title}</h3>
        </div>
        <div className="side-panel-actions">
          {status && <span className="status-pill">{status}</span>}
          {variant === 'panel' && onClose && (
            <button type="button" className="icon-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          )}
        </div>
      </div>
      <div className="side-panel-body">{children}</div>
    </aside>
  );
}
